
import React, { Component } from "react"
import ReactDOM from "react-dom"
import _ from 'underscore'
import I18n from "../../utils/i18n.js"

import RangeSelector from '../../utils/range_selector'
import GiteAdvancedFacetForm from '../forms/gite_advanced_facet_form'
import AccommodationsSelectedFacets from '../selected_facets'
import FacetSelect2 from '../../utils/facet_select2'

import { default as DateRange } from '../date_range'

import createReactClass from 'create-react-class'
export default createReactClass({
  getDefaultProps() {
    return {
      filters: [],
      results: 0,
      options: {},
      map: null,
      absolute_price_max: 5000,
      place: null
    };
  },

  handleChange(e) {
    const self = this;
    const filters = {'booleans':[], 'languages':[], 'areas':[]};

    if (this.props.filters && _.contains(this.props.filters.booleans, 'booking')) {
      filters.booleans.push('booking')
    }

    $.each(['last_minute', 'corona_policy'], function(key, value) {
      if (self.refs[value].checked) { return filters['booleans'].push(value); }
    });


    //advanced form
    $.each(this.refs.advanced_form.refs, function(key, value) {
      switch (key) {
        case 'bedrooms':
        case 'bathrooms':
        case 'two_person_beds':
        case 'one_person_beds':
        case 'regions':
        case 'departments':
          const val = value.getValue();
          if (val) {
            filters[key] = val;
          }

          return;
      }
      const node = ReactDOM.findDOMNode(value);
      switch (node.name) {
        case 'language':
          if (node.checked) { return filters['languages'].push(key); }
          break;
        case 'boolean':
          if (node.checked) { return filters['booleans'].push(key); }
          break;
        case 'areas':
          if (node.checked) { return filters['areas'].push(key); }
          break;
        default:
          if ((node.value !== "") && (key !== "places")) { return filters[key] = node.value; }
      }
    });

    $.each(['max_persons'], function(key, value) {
      const input = ReactDOM.findDOMNode(self.refs[value]).value;
      if (input) { return filters[value] = input; }
    });

    filters['max_persons'] = self.refs.max_persons.getValue();
    const dateRange = self.refs.date_range.getValue();
    if (dateRange) {
      if (dateRange.startDate) {
        //The if(typeof...) fixes a bug that broke the selectionmenu.
        //When the user changes the start or enddate dateRange contains 2 Moment objects
        //However, when the user checks a checkbox dateRange.startDate is a formatted string.
        if(typeof dateRange.startDate === "string") {
          filters['start_date'] = dateRange.startDate;
        } else {
          filters['start_date'] = dateRange.startDate.format("DD-MM-YYYY");
        }
      }

      if (dateRange.endDate) {
        if(typeof dateRange.endDate === "string") {
          filters['end_date'] = dateRange.endDate;
        } else {
          filters['end_date'] = dateRange.endDate.format("DD-MM-YYYY");
        }
      }
    }

    const min_price = this.refs.price_range.refs.range_min.getValue()
    const max_price = this.refs.price_range.refs.range_max.getValue()
    if (/^\d+$/.test(min_price)) { filters['min_price'] = min_price; }
    if (/^\d+$/.test(max_price)) { filters['max_price'] = max_price; }
    filters['free_text'] = this.refs.free_text.value;

    return this.props.onFormChange(filters);
  },

  handleFormChange(filters) {
    return this.props.onHandleFormChange(filters);
  },

  handleFormExpand(e) {
    $(".facets-inner").animate({ scrollTop:0 });

    const adverts_type = this.props.options.type;

    return $('.advanced-filters').slideToggle(function() {
      let text;
      if ($(this).is(':visible')) {
        text = `&#8722; ${I18n.t('search.less_filters')}`;
        $.cookie( adverts_type + '_expanded', true );
      } else {
        text = `&#43; ${I18n.t('search.more_filters')}`;
        $.cookie( adverts_type + '_expanded', false );
      }
      return $('.toggle-filters').html(text);
    });
  },

  render() {
    let option_count;
    const filters = this.props.filters || {};
    const self = this;

    const persons = self.props.filters !== null ? self.props.filters['max_persons'] : undefined;

    const min = filters['min_price'];
    const max = filters['max_price'];
    const last_minute_checked = this.props.filters && _.contains(this.props.filters['booleans'], 'last_minute');
    const corona_policy_checked = this.props.filters && _.contains(this.props.filters['booleans'], 'corona_policy');

    const person_options = [];
    for (option_count = 1; option_count <= 20; option_count++) {
      person_options.push({ value: option_count, label: I18n.t('search.persons_count', {count: option_count}) });
    }

    person_options.push({ value: option_count, label: I18n.t('search.more_than_twenty') })

    const free_text = (this.props.filters && this.props.filters.free_text) || "";

    return <div>
      <div className={this.props.className}>
        <form ref='form' onChange={this.handleChange}>
          <div className='filters-top'>
            <div className='form-row'>
              <div className='form-cell'>
                <div className='form-row date-pickers'>
                  <div className='form-cell'>
                    <DateRange
                      startDate={this.props.filters.start_date}
                      endDate={this.props.filters.end_date}
                      ref="date_range"
                      onChange={() => this.handleChange()}
                    />
                  </div>
                </div>
              </div>
              <div className='form-cell cell-33 persons-wrapper'>
                <FacetSelect2
                  ref="max_persons"
                  value={persons}
                  options={person_options}
                  placeholder={I18n.t('search.persons')}
                  className='guests-dropdown input--white'
                  onChange={() => this.handleChange()}
                />
              </div>
            </div>
            <div className='form-row'>
              <div className='form-cell'>
                <RangeSelector ref="price_range" key="price_range" options={self.props.options.price_options} onChange={this.handleChange} min={min} max={max} className='input--white' />
              </div>
              <div className='form-cell cell-33'>
                <div className='checkboxes last-minute'>
                  <input type='checkbox' key='last_minute' id="last_minute" ref='last_minute' readOnly={true} checked={last_minute_checked}></input>
                  <label className="last_minute" htmlFor="last_minute">{I18n.t('search.attributes.last_minute')}</label>
                </div>
                <div className='checkboxes'>
                  <input type='checkbox' key='corona_policy' id="corona_policy" ref='corona_policy' readOnly={true} checked={corona_policy_checked}></input>
                  <label className="corona_policy" htmlFor="corona_policy">{I18n.t('search.attributes.corona_policy')}</label>
                </div>
              </div>
            </div>
          </div>
          <div className={`advanced-filters ${this.props.options.expanded ? 'show' : 'hidden'}`}>
            <GiteAdvancedFacetForm options={this.props.options} map={this.props.map} facets={this.props.facets} ref="advanced_form" filters={this.props.filters} onFormChange={self.handleChange} />
            <div className="form-row facets__search">
              <div className="form-cell cell-33">
                <label htmlFor="free_text" className="filter__label filter__label--indent">{I18n.t('search.form_labels.free_text')}</label>
              </div>
              <div className="form-cell">
                <input type='text' className='input--white' placeholder={I18n.t('search.placeholders.fulltext')} onChange={this.handleChange} key='free_text' id="free_text" ref='free_text' value={free_text}></input>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="filter-results-top">
        <AccommodationsSelectedFacets blacklist={this.props.options.tags_blacklist} filters={this.props.filters} onDeselect={this.handleFormChange} options={this.props.options} />
        <div className='toggle-filters btn-cta' onClick={this.handleFormExpand}>
          {this.props.options.expanded ? (`- ${I18n.t('search.less_filters')}`) : (`+ ${I18n.t('search.more_filters')}`)}
        </div>
      </div>
    </div>;
  }
});
